import React from 'react';
import { View } from 'react-native';
import CaptureButtonSvg from '@assets/images/svg/doc-capture/capture-button.svg';

export interface CaptureButtonIconProps {
    size?: number;
}

export function CaptureButtonIcon({ size = 66 }: CaptureButtonIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CaptureButtonSvg width={size} height={size} />
        </View>
    );
}

export default CaptureButtonIcon;

